import moduleConfig from './module-config';
import netsCallWrapup from './nets-call-wrapup';

export default angular
  .module('app.call-wrapup', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsCallWrapup', netsCallWrapup);
